// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3e_JY","list":"PatternAutocomplete_list__3gry_"};